var $ = require('jquery');
var Msal = require('msal');
var Backbone = require('backbone');
var Logger = require('Logger');
var API = EY.Consultation.Lookups.API.Consultation;
var Azure = EY.Consultation.Lookups.Azure;
var ALTERNATIVE_FRONTEND_IDENTITY = EY.Consultation.Lookups.Configuration.ALTERNATIVE_FRONTEND_IDENTITY;

var User = Backbone.Model.extend({
    defaults: {
        _id: '',
        active: true,
        adStatus: true,
        displayName: '',
        preferences: {},
        geography: '//',
        givenName: '',
        email: '',
        physicalDeliveryOfficeName: '',
        roles: [],
        upn: '',
        gpn: '',
        privacyAck: false,
        privacyAckDate: '',
        privacyAckVersion: ''
    },
    urlRoot: API + 'User'
});

var msalConfig = {
    auth: {
        clientId: Azure.ClientId, // Azure Portal > Azure Active Directory > App Registrations > Consultation Application Id 
        instance: Azure.TenantHostUrl,
        redirectUri: window.location.origin + '/',
        tenant: Azure.TenantId, //Azzure Portal > Azure Active Directory > Properties > Directory ID
        authority: 'https://login.microsoftonline.com/' + Azure.TenantId
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: true,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case Msal.LogLevel.Error:
                        console.error(message);
                        return;
                    case Msal.LogLevel.Info:
                        console.info(message);
                        return;
                    case Msal.LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case Msal.LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            },
        }
    }
};

//This function is used to get an access token for CDA API
function getCDAToken(msalInstance, account) {

    var cdaApiScopes = {
        scopes: ['api://' + Azure.EdwCDAScope + '/.default'],
        account: account
    };
    msalInstance.acquireTokenSilent(cdaApiScopes).then(function (apiToken) {
        Azure.CDAToken = apiToken.accessToken;
    }).catch(function(error) { 
        console.log('Error fetching CDA token ' + error); 
    });
}

module.exports.configure = function () {

    var deferred = $.Deferred();
    var promise = deferred.promise();
    var msalInstance = new Msal.PublicClientApplication(msalConfig);
    var msalGraphScopes = {
        scopes: ["openid", "profile", "user.read"]
    };

    var handleAcquireTokenError = function (error){
        console.log(error);

        //https://github.com/AzureAD/microsoft-authentication-library-for-js/pull/4314
        //https://github.com/AzureAD/microsoft-authentication-library-for-js/issues/4295
        //https://github.com/AzureAD/microsoft-authentication-library-for-js/issues/3950

        msalInstance.browserStorage.clearItemCookie('msal.interaction.status');
        msalInstance.browserStorage.setInteractionInProgress(false);
        msalInstance.browserStorage.cleanRequestByInteractionType(Msal.InteractionType.Redirect);
        
        if (error instanceof Msal.InteractionRequiredAuthError) {
            msalInstance.loginRedirect(msalGraphScopes);
        }
    }

    msalInstance.handleRedirectPromise().then(function(redirectResponse) {
        var account = getUserAccount(msalInstance);
        if(!account) {
            msalInstance.loginRedirect(msalGraphScopes);
        } else {
            msalInstance.acquireTokenSilent({
                scopes: msalGraphScopes.scopes,
                account: account
            }).then(function (response) { Azure.GraphToken = response.accessToken; })
            .catch(handleAcquireTokenError);
            var msalApiScopes = {
                scopes: ['api://' + Azure.ClientId + '/user_impersonation'],
                account: account
            };

            //Fetch and set the CDA Token
            getCDAToken(msalInstance, account);
            
            msalInstance.acquireTokenSilent(msalApiScopes).then(function (apiToken) {
                
                Azure.Token = apiToken.accessToken;
                var bearer = 'Bearer ' + apiToken.accessToken;
                var graphParams = 'me?$select=givenName,surname,mail,country,jobTitle,' + ALTERNATIVE_FRONTEND_IDENTITY;

                $.ajax({
                    // Since Graph API default response doesn't contains specific details,
                    // using $select to get the subset of required properties.
                    url: Azure.GraphUrl + graphParams
                }).done(function (me) {

                    var upn = me[ALTERNATIVE_FRONTEND_IDENTITY].replace(/'/g, '`').toLowerCase();

                    var user = new User({ _id: upn, id: upn });

                    user.fetch({
                        headers: {
                            "Authorization": bearer
                        }
                    }).done(function () {
                        setEYUser(user, me, upn);
                        deferred.resolve();
                    });
                });
            })
            .catch(handleAcquireTokenError);
        }
    })
    return promise;
};

module.exports.logout = function () {
    var msalInstance = new Msal.PublicClientApplication(msalConfig);

    const logoutRequest = {
        postLogoutRedirectUri: window.location.origin + '/Consultation/Logoff?culture=' + EY.Consultation.CurrentCulture
    };

    msalInstance.logoutRedirect(logoutRequest).catch(function (error) {
        Logger.log('Logout failure', error);
    });
};

function getUserAccount(msalInstance) {
    var accounts = msalInstance.getAllAccounts();
    return accounts.length ? accounts[0] : []
}

function setEYUser(user, me, upn) {
    EY.Consultation.CurrentUser = {
        givenName: me.givenName + ' ' + me.surname,
        gpn: user.get('gpn'),
        location: { country: me.country },
        upn: upn,
        model: user,
        rank: me.jobTitle
    };
    EY.Consultation.Lookups.IsHandHeldDevice &&
        Logger.logToServer(JSON.stringify({
            device: EY.Consultation.Lookups.IsHandHeldDevice[0],
            rank: EY.Consultation.CurrentUser.rank,
            location: EY.Consultation.CurrentUser.location.country,
            action: 'Login'
        }), 'handHeldDevice');
    Logger.log('-MSAL- me@GraphAPI', me);
}


// WEBPACK FOOTER //
// ./js/Modules/Security/Authentication.js